export default "__VITE_ASSET__VTzu5LmG__"